import { initialState } from "./state"

export default {
  setCep: (state, payload) => (state.cep = payload),
  setAddress: (state, payload) => (state.address = payload),
  setNumber: (state, payload) => (state.number = payload),
  setNoNumber: (state, payload) => (state.noNumber = payload),
  setNeighborhood: (state, payload) => (state.neighborhood = payload),
  setState: (state, payload) => (state.state = payload),
  setCity: (state, payload) => (state.city = payload),
  setCityId: (state, payload) => (state.cityId = payload),
  setLatitude: (state, payload) => (state.latitude = payload),
  setLongitude: (state, payload) => (state.longitude = payload),
  setAvailableBoxes: (state, payload) => (state.availableBoxes = payload),
  setCoverageArea: (state, payload) => (state.coverageArea = payload),
  setStateId: (state, payload) => (state.stateId = payload),
  setSecondaryAddress: (state, payload) => (state.secondaryAddress = payload),
  setProviderAddressUuid: (state, payload) =>
    (state.providerAddressUuid = payload),
  setCto: (state, payload) => (state.cto = payload),
  updateAddressId: (state, payload) => (state.addressId = payload),
  updateAddressGroupDescription: (state, payload) =>
    (state.addressGroupDescription = payload),
  updateAddressGroupUnity: (state, payload) =>
    (state.addressGroupUnity = payload),
  updateAddressGroupUnityInformation: (state, payload) =>
    (state.addressGroupUnityInformation = payload),
  updateAddressGroupUnityName: (state, payload) =>
    (state.addressGroupUnityName = payload),
  resetAddress: state => {
    const init_state = initialState()
    Object.keys(state).forEach(key => {
      state[key] = init_state[key]
    })
  },
  setComplement: (state, payload) => (state.complement = payload),
  updateComplement: (state, payload) => {
    state.complement[payload.index][payload.key] = payload.value
  },
  setCondominiumComplement: (state, payload) => (state.condominiumComplement = payload),
  updateCondominiumComplement: (state, payload) => {
    state.condominiumComplement[payload.key] = payload.value
  },
  setCurrentLatitude: (state, payload) => (state.currentLatitude = payload),
  setCurrentLongitude: (state, payload) => (state.currentLongitude = payload),
  setCepForCurrentLocation: (state, payload) =>
    (state.cepFromCurrentLocation = payload),
  setHasMadeCepFromCurrentLocationRequest: (state, payload) =>
    (state.hasMadeCepFromCurrentLocationRequest = payload),
  setLocationType: (state, payload) => state.locationType = payload,
  setReferencePoint: (state, payload) => state.referencePoint = payload
}
